

<template>
  <div class="main_Container">
    <section>
      <div class="container-fluid">
        <div class="section__top">
          <h2 class="section__title">ثقف نفسك</h2>
          <div class="section__buttons">
            <router-link to="/informations/add_information" class="btn add">
              <i class="fas fa-plus ms-1"></i>
              إضافة معلومة جديد
            </router-link>

            <div class="dropdown sorting">
              <button
                class="btn add me-2 dropdown-toggle"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                type="button"
              >
                <i class="fas fa-filter ms-1"></i>
                ترتيب {{ this.currentView }}
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li class="dropdown-item" @click="sortByCreateDate">
                  ترتيب حسب التاريخ
                </li>
                <li class="dropdown-item" @click="sortByName">
                  ترتيب حسب الاسم
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="data">
          <div v-show="this.isloading" class="data__loading">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <div v-show="!this.isloading" class="table-responsive">
            <form @submit.prevent="">
              <div class="searching">
                <div class="form-group">
                  <input
                    type="search"
                    @input="getDocBySeacrh"
                    v-model="searchValue"
                    class="form-control mt-2"
                    placeholder="هل تبحث عن ...."
                    required
                  />
                </div>
              </div>
            </form>
            <table
              v-show="this.informations.length > 0"
              class="table table-striped"
            >
              <thead>
                <tr>
                  <th scope="col">الرقم</th>
                  <th scope="col">عنوان</th>
                  <th scope="col">النوع</th>
                  <th style="width: 40%" scope="col">الوصف</th>
                  <th style="width: 30%" scope="col">التحكم</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(information, index) in this.informations"
                  :key="index"
                >
                  <th scope="row">{{ index + 1 }}</th>
                  <td>{{ information.title }}</td>
                  <td>{{ filterItems(information.information_type) }}</td>
                  <td>{{ information.short_description }}</td>
                  <td>
                    <router-link
                      class="btn view"
                      :to="{
                        name: 'view_information',
                        params: { id: information.information_id },
                      }"
                    >
                      <i class="fas fa-folder ms-1"></i>
                      عرض
                    </router-link>
                    <router-link
                      class="btn edit me-2"
                      :to="{
                        name: 'edit_information',
                        params: { id: information.information_id },
                      }"
                    >
                      <i class="fas fa-edit"></i>
                      تعديل
                    </router-link>

                    <button
                      class="btn me-2 delete"
                      @click="this.deleteSelectedInformation(information)"
                    >
                      <i class="fas fa-trash-alt ms-2"></i>
                      حذف
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
            <div
              v-show="
                (!this.isloading && !this.informations) ||
                this.informations.length == 0
              "
              class="empty-state"
            >
              <div class="empty-state__icon">
                <i class="fas fa-folder"></i>
              </div>
              <h3 class="empty-state__text">لا يوجد معلومات حتى الآن</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
// Swal
import Swal from "sweetalert2";
// Delete from firebase Storage
import { deleteFileFromUrl } from "@/firebase/firebase_storage";
export default {
  data() {
    return {
      currentView: "المعلومات",
      informations: [],
      // Loading
      isloading: false,
      firstLoad: "",
      // Search
      searchValue: "",
    };
  },
  methods: {
    ...mapActions("informationsModule", [
      "fetchInformations",
      "deleteInformation",
    ]),

    //-----------------------------------------------
    // Sort
    sortByCreateDate() {
      this.informations.sort(
        (a, b) => b.created_date.seconds - a.created_date.seconds
      );
    },
    sortByName() {
      this.informations.sort((a, b) => (a.title < b.title ? -1 : 1));
    },
    //-----------------------------------------------

    //-----------------------------------------------
    // Search
    getDocBySeacrh() {
      setTimeout(() => {
        var re = new RegExp(this.searchValue + ".+$", "i");
        this.informations = this.getInformations.filter(
          (item) => item.title.search(re) != -1
        );
      }, 800);
    },
    //-----------------------------------------------
    //--------------------------------------------
    // Get Information By ID
    // Delete Information
    deleteSelectedInformation(information) {
      Swal.fire({
        text: "هل أنت متأكد من حذف هذا المعلومة؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            text: "تم حذف المعلومة بنجاح",
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          this.deleteInformation(information.information_id);
          deleteFileFromUrl(information.thumbnail_url);
          deleteFileFromUrl(information.file_url);
        }
      });
      console.log(information);
    },

    //--------------------------------------------
    filterItems(type) {
      switch (type) {
        case 1:
          return "نص";
        case 2:
          return "صورة";
        case 3:
          return "ملف";
        case 4:
          return "فيديو";
      }
    },
  },
  async created() {
    if (this.isFirstLoad) await this.fetchInformations();
  },
  computed: {
    ...mapGetters("informationsModule", [
      "getInformations",
      "isLoading",
      "isFirstLoad",
    ]),
  },
  mounted() {
    this.informations = this.getInformations;
    this.isloading = this.isLoading;
    this.firstLoad = this.isFirstLoad;
  },
  watch: {
    getInformations() {
      this.informations = this.getInformations;
    },
    isLoading() {
      this.isloading = this.isLoading;
    },
    isFirstLoad() {
      this.firstLoad = this.isFirstLoad;
    },
  },
};
</script>

<style>
</style>